"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class AdyenPaymentDetailsStore {
    api = new ecommerce_1.AdyenApi(configuration_1.default);
    savePaymentDetails(orderId, stateData) {
        return this.api.postAdyenPaymentDetails({ adyenPaymentDetailsRequestBody: { orderId, stateData } });
    }
}
exports.default = new AdyenPaymentDetailsStore();
